import { useState, useEffect } from 'react'

const API_BASE = ''

export default function SalespersonOverviewPage() {
  const [institutions, setInstitutions] = useState([])
  const [salespersons, setSalespersons] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedInstitution, setSelectedInstitution] = useState('all')
  const [stats, setStats] = useState(null)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    setLoading(true)
    try {
      // 加载机构列表（先从业务员表查出有哪些机构ID）
      const res = await fetch(API_BASE + '/cms/api/institution-salespersons')
      const json = await res.json()
      if (json.success) {
        const list = json.data || []
        setSalespersons(list)

        // 汇总机构
        const instMap = {}
        list.forEach(s => {
          if (!instMap[s.institution_id]) {
            instMap[s.institution_id] = {
              institution_id: s.institution_id,
              count: 0,
              total_commission: 0
            }
          }
          instMap[s.institution_id].count++
          instMap[s.institution_id].total_commission += parseFloat(s.total_commission || 0)
        })
        setInstitutions(Object.values(instMap))
      }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const loadStats = async () => {
    try {
      const res = await fetch(API_BASE + '/cms/api/institution-salespersons/summary')
      const json = await res.json()
      if (json.success) setStats(json.data)
    } catch (e) { console.error(e) }
  }

  const filteredSales = selectedInstitution === 'all'
    ? salespersons
    : salespersons.filter(s => s.institution_id === selectedInstitution)

  const totalSalespersons = salespersons.length
  const totalCommission = salespersons.reduce((s, p) => s + parseFloat(p.total_commission || 0), 0)
  const totalSales = salespersons.reduce((s, p) => s + parseFloat(p.total_sales || 0), 0)

  return (
    <div style={{ padding: 24, maxWidth: 1200 }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px 0' }}>👤 业务员总览</h1>
      <p style={{ fontSize: 13, color: '#888', margin: '0 0 24px 0' }}>
        查看所有入驻机构的业务员配置与业绩概览
      </p>

      {/* 统计卡片 */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
        {[
          { label: '机构数', value: institutions.length, color: '#1890ff' },
          { label: '业务员总数', value: totalSalespersons, color: '#52c41a' },
          { label: '累计业绩(¥)', value: (totalSales).toLocaleString(), color: '#722ed1' },
          { label: '累计提成(¥)', value: (totalCommission).toLocaleString(), color: '#fa8c16' },
        ].map(card => (
          <div key={card.label} style={{
            background: '#fff', borderRadius: 12, padding: '16px 24px',
            flex: 1, boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }}>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 8 }}>{card.label}</div>
            <div style={{ fontSize: 26, fontWeight: 700, color: card.color }}>{card.value}</div>
          </div>
        ))}
      </div>

      {/* 机构筛选 */}
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <label style={{ fontSize: 13, color: '#666' }}>按机构筛选：</label>
        <select
          value={selectedInstitution}
          onChange={e => setSelectedInstitution(e.target.value)}
          style={{ padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13, width: 200 }}
        >
          <option value="all">全部机构（{institutions.length}个）</option>
          {institutions.map(inst => (
            <option key={inst.institution_id} value={inst.institution_id}>
              {inst.institution_id}（{inst.count}人）
            </option>
          ))}
        </select>
        <span style={{ fontSize: 12, color: '#999' }}>
          当前显示: {filteredSales.length} 人
        </span>
      </div>

      {/* 表格 */}
      <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>姓名</th>
              <th style={th}>手机号</th>
              <th style={th}>所属机构</th>
              <th style={th}>提成比例</th>
              <th style={th}>累计业绩</th>
              <th style={th}>累计提成</th>
              <th style={th}>状态</th>
              <th style={th}>创建时间</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</td></tr>
            ) : filteredSales.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无业务员数据</td></tr>
            ) : filteredSales.map(s => (
              <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{s.name}</td>
                <td style={{ ...td, fontFamily: 'monospace' }}>{s.phone}</td>
                <td style={td}>
                  <span style={{ background: '#f0f5ff', padding: '2px 8px', borderRadius: 4, fontSize: 12, color: '#1890ff' }}>
                    {s.institution_id}
                  </span>
                </td>
                <td style={td}>
                  <span style={{ fontWeight: 600, color: '#fa8c16' }}>{s.commission_rate}%</span>
                </td>
                <td style={td}>¥{parseFloat(s.total_sales || 0).toLocaleString()}</td>
                <td style={td}>¥{parseFloat(s.total_commission || 0).toLocaleString()}</td>
                <td style={td}>
                  <span style={{
                    padding: '2px 8px', borderRadius: 4, fontSize: 12,
                    background: s.status === 'active' ? '#f6ffed' : (s.status === 'frozen' ? '#fff7e6' : '#fff2f0'),
                    color: s.status === 'active' ? '#52c41a' : (s.status === 'frozen' ? '#faad14' : '#ff4d4f')
                  }}>
                    {s.status === 'active' ? '正常' : s.status === 'frozen' ? '冻结' : '停用'}
                  </span>
                </td>
                <td style={td}>{s.created_at ? s.created_at.slice(0, 10) : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 说明 */}
      <div style={{ background: '#f0f5ff', borderRadius: 12, padding: 16, marginTop: 20, fontSize: 13, color: '#666' }}>
        <strong>💡 说明</strong>
        <ul style={{ margin: '8px 0 0 0', paddingLeft: 20, lineHeight: 2 }}>
          <li>业务员由各机构在"合作伙伴工作台 → 业务员管理"中自行添加管理</li>
          <li>销售数据来源于订单结算系统，提成比例由机构自行设置</li>
          <li>冻结状态的业务员无法产生新的推广佣金</li>
        </ul>
      </div>
    </div>
  )
}

const th = {
  padding: '10px 12px', textAlign: 'left', fontSize: 13,
  fontWeight: 600, color: '#333', borderBottom: '2px solid #e8e8e8',
  whiteSpace: 'nowrap'
}
const td = {
  padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #f0f0f0',
  whiteSpace: 'nowrap'
}
